export default __webpack_public_path__ + "locales/pl/RoomLogoCover.json?hash=352281726f6d7fb769aaaf8b751f8788";